// react core
import { useContext } from "react";

// material design
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import Accordion from "@mui/material/Accordion";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// entzy context
import configEntzy from "components/config/ConfigEntzy";
import { EventContext } from "components/event/EventContext";
// import { ActionBoxButton } from "components/utils/common/CommonButtons";
// import { ActionLoader } from "components/utils/common/CommonLoaders";
import { ModuleSubHeaderTag } from "components/utils/common/CommonTags";

// entzy components
import ActionMessagingSettings from "./ActionMessagingSettings";
import ActionMessagingSelectorDates from "./ActionMessagingSelectorDates";

// fonts and colors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBell as iconNotifications } from "@fortawesome/pro-duotone-svg-icons";
import { faPortalEnter as iconEnterRoom } from "@fortawesome/pro-solid-svg-icons";
import { faArrowRight as iconArrowRight } from "@fortawesome/pro-solid-svg-icons";

function ActionMessagingSelector(props) {
  // const user = props.user;
  const handleCloseAction = props.handleCloseAction;

  const eventContext = useContext(EventContext);

  // const notificationsActive =
  //   eventContext.state.messaging.rooms[eventContext.state.messaging.activeRoom]
  //     .settingsHydrated &&
  //   (eventContext.state.messaging.rooms[eventContext.state.messaging.activeRoom]
  //     .settingsData.mail ||
  //     eventContext.state.messaging.rooms[
  //       eventContext.state.messaging.activeRoom
  //     ].settingsData.push);

  // const isAiRoom = eventContext.state.messaging.activeRoom.startsWith("ai");

  const visibleRooms = Object.keys(eventContext.state.messaging.rooms).filter(
    (key) =>
      !key.startsWith("ai") &&
      !(
        (key.includes("runner") && !eventContext.state.event.manager) ||
        (key.includes("rider") && eventContext.state.event.manager)
      ) &&
      !key.includes("|"),
  );
  // move front desk to the front
  // const deskIndex = visibleRooms.indexOf("desk");
  // if (deskIndex > -1) {
  //   visibleRooms.splice(deskIndex, 1);
  //   visibleRooms.unshift("desk");
  // }

  return (
    <Box className="box-default">
      {/* <Box className="box-default">
        <ModuleSubHeaderTag
          text={
            <span>
              <span>Settings for Room</span>
              <span>&nbsp;</span>
              <span className="proper-case">
                {eventContext.state.messaging.activeRoom.replace("|", " | ")}
              </span>
            </span>
          }
          boxSx={{
            pt: configEntzy.APP_SPACING_MD2X,
            pb: configEntzy.APP_SPACING_MD,
            px: configEntzy.APP_SPACING_MD2X,
          }}
        />
      </Box>
      <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
        <ActionMessagingSettings
          {...props}
          key={eventContext.state.messaging.activeRoom}
          source="selector"
          viewer={eventContext.state.event.manager ? "runner" : "rider"}
        />
      </Box> */}
      <Box className="box-default">
        <ModuleSubHeaderTag
          text="Available Standard Rooms"
          boxSx={{
            pt: configEntzy.APP_SPACING_MD3X,
            pb: configEntzy.APP_SPACING_MD,
            px: configEntzy.APP_SPACING_MD2X,
          }}
        />
      </Box>
      <Box
        className="box-default"
        sx={{
          pt: configEntzy.APP_SPACING_MD,
        }}
      >
        {visibleRooms.map((key, index) => {
          const room = eventContext.state.messaging.rooms[key];
          return (
            <Box
              key={room.name}
              className="box-default bg-black-t50"
              sx={{
                mb: configEntzy.APP_SPACING_SM,
                borderRadius: configEntzy.BORDER_SIZE_XL,
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor:
                  eventContext.state.messaging.activeRoom === room.name
                    ? "darkorange"
                    : "transparent",
              }}
            >
              <Box className="box-default flex-center half-width">
                <ActionMessagingSettings
                  {...props}
                  roomName={room.name}
                  source="selector"
                  viewer={eventContext.state.event.manager ? "runner" : "rider"}
                />
              </Box>
              <Box
                className="box-default half-width text-left action-pointover"
                sx={{
                  py: configEntzy.APP_SPACING_MD,
                  px: configEntzy.APP_SPACING_MD,
                  borderTopRightRadius: configEntzy.BORDER_SIZE_XL,
                  borderBottomRightRadius: configEntzy.BORDER_SIZE_XL,
                  borderLeft: "1px solid black",
                }}
                onClick={() => {
                  eventContext.setMessageRoom(room.name);
                  handleCloseAction();
                }}
              >
                <Typography variant="subtitle2" color="primary.dark">
                  {room.title}
                </Typography>
                <Typography variant="body2" color="grey.500">
                  {room.description}
                </Typography>
                <Typography
                  variant="body2"
                  color="grey.400"
                  className="upper-case"
                  sx={{ mt: configEntzy.APP_SPACING_SM }}
                >
                  {eventContext.state.messaging.activeRoom === room.name ? (
                    <span
                      className="bg-orange"
                      style={{
                        padding: "2px 8px",
                        borderRadius: "12px",
                        color: "black",
                      }}
                    >
                      Active Room
                    </span>
                  ) : (
                    <span>
                      <span>Open Room</span>
                      <span>&nbsp;&nbsp;</span>
                      <FontAwesomeIcon icon={iconArrowRight} />
                      <FontAwesomeIcon icon={iconEnterRoom} />
                    </span>
                  )}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
      <Box className="box-default">
        <Box className="box-default">
          <ModuleSubHeaderTag
            text="Available Side Rooms"
            boxSx={{
              pt: configEntzy.APP_SPACING_MD3X,
              pb: configEntzy.APP_SPACING_MD,
              px: configEntzy.APP_SPACING_MD2X,
            }}
          />
        </Box>
        <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
          <ActionMessagingSelectorDates {...props} />
        </Box>
      </Box>
    </Box>
  );
}

export default ActionMessagingSelector;
